import { MeResponseSchema, type MeResponse } from '../schemas/me';

const CC = { id: 'cc', name: 'Customer Care' };
const PRODUCT = { id: 'product', name: 'Producto' };

// One payload per combination of roles and permissions a screen has to handle.
export const meFixtures = {
  // Both roles, so mock mode also shows permissions adding up. Never `access.*`.
  default: {
    roles: [CC, PRODUCT],
    permissions: [
      'care.search',
      'operations.amazon_door_access',
      'operations.carrier_exclusion_lists',
    ],
  },
  cc: { roles: [CC], permissions: ['care.search'] },
  // A per-person extra on top of a role.
  ccWithDoorAccess: { roles: [CC], permissions: ['care.search', 'operations.amazon_door_access'] },
  productOnly: {
    roles: [PRODUCT],
    permissions: ['operations.amazon_door_access', 'operations.carrier_exclusion_lists'],
  },
  noPermissions: { roles: [], permissions: [] },
} satisfies Record<string, MeResponse>;

export type MeFixture = keyof typeof meFixtures;

let current: MeFixture = 'default';

export function setMeMockFixture(fixture: MeFixture): void {
  current = fixture;
}

export function resetMeMock(): void {
  current = 'default';
}

export async function getMeMock(): Promise<MeResponse> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  // Through the same parse as the real read; a parse also returns a fresh copy, so a caller that
  // mutates the result cannot change the fixture for the next read.
  return MeResponseSchema.parse(meFixtures[current]);
}
